import { ReportRepository } from "../repositories";
export class ReportProcess {
    private reportRepository: ReportRepository;

    constructor() {
        this.reportRepository = new ReportRepository();
    }

    async getDashboardById(code: string, payload: any): Promise<string> {
        const response = await this.reportRepository.getReport(code, payload)
        return response.data;
    }

    async getReportById(code: string, payload: any): Promise<string> {
        const response = await this.reportRepository.getReport(code, payload);
        return response.data;
    }

}
